import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit {
  constructor() {}

  @Input() entriesOptions: number[] = [5, 10, 25, 50, 100];
  @Input() selectedEntries: number = 10;
  @Input() collectionSize: number = 100;
  @Input() page: number = 1;

  @Output() selectedEntriesChange = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();

  totalPages: number = 0;

  ngOnInit(): void {
    this.reCalculatePages();// to recalcuate number of pages 
  }

  onEntriesChange(event: number): void {
    this.selectedEntries = event;
    this.selectedEntriesChange.emit(this.selectedEntries);
    this.reCalculatePages();
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
    if (this.page >= 1) {
      this.pageChange.emit(this.page);
    }
  }

  reCalculatePages(): void {
    if (this.collectionSize == null || this.collectionSize < 0) {
      return;
    }
    if (this.collectionSize === 0) {
      this.totalPages = 1;
      this.page = 1;
      return;
    }
    this.totalPages = Math.ceil(this.collectionSize / this.selectedEntries);
    if (this.page > this.totalPages) {
      this.page = this.totalPages;
      this.onPageChange(this.page);
    }
  }
}
